import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { UserRole, UserSelectedPlan, PagePermission, PlanPermissions, DataParam } from '../Enum/Enum';
import { flatMap } from 'rxjs/operators';
import { CurrencyPipe } from '@angular/common';
import { openLoginModal } from './eventEmitter';

@Injectable({
  providedIn: 'root'
})
export class AccessPermissionGuard implements CanActivate {

  constructor(private router: Router, private toastr: ToastrService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let pagepath = '';
    let curentPage;
    if (state.url != '/') {
      let pageLink = state.url.split('/');
      if (pageLink != null && pageLink.length > 1) {
        pagepath = pageLink[1];
      }
      curentPage = pagepath;
    }
    else {
      curentPage = state.url;
    }

    console.log(curentPage);


    var currentUser = localStorage.getItem('currentUser');
    var loggedInUser = (currentUser != null && currentUser != '' && currentUser != undefined) ? JSON.parse(currentUser) : null;
/*
    let landingSearchJson = localStorage.getItem(DataParam.LandingPageSearch.toString());
    if (curentPage === 'searchresultssplash' && landingSearchJson) {
      this.router.navigate(['/searchresult']);
    }*/
/*
    let voyageTrackerSearchJson = localStorage.getItem(DataParam.VoyageTrackerSearch.toString());
    if (curentPage === 'voyagetrackersplash' && voyageTrackerSearchJson) {
      this.router.navigate(['/voyagetracker']);
    }
*/
    if (curentPage === 'searchresultsplash' || curentPage === 'voyagetrackersplash' || curentPage === 'searchresult' || curentPage === 'voyagetracker' || curentPage === 'portcalendarsplash' || curentPage === 'tracking' || curentPage === 'portcalendar' || curentPage === 'raterequestlist'|| curentPage === 'raterequest') {
      return true;
    }



    if (loggedInUser != null && loggedInUser.usersDetailsVM != null && (loggedInUser.usersDetailsVM.userRole != null && loggedInUser.usersDetailsVM.userRole != '')) {
      if (loggedInUser.usersDetailsVM.userRole == UserRole.SuperAdmin) {
        return true
      }
      else {
        var isValid = false;
        if (loggedInUser.usersDetailsVM.planId == UserSelectedPlan.Elite) {
          if (loggedInUser.usersDetailsVM.isPlanExpiried == false) {
            var flag = this.getPermission(curentPage, loggedInUser.usersDetailsVM.planPermission, loggedInUser.usersDetailsVM.planId)
            isValid = flag;
          }
          else {
            this.toastr.warning('Your plan is expired, Please purchase plan', 'Oops !');
            this.router.navigate(['/planselection']);
            return false;
          }
        }
        else if (loggedInUser.usersDetailsVM.planId == UserSelectedPlan.Basic) {
          // if (loggedInUser.usersDetailsVM.isPlanExpiried == false) {
          //   if (curentPage == PagePermission.Searchresult && loggedInUser.usersDetailsVM.totalSearchCount > loggedInUser.usersDetailsVM.planDuration) {
          //       this.toastr.warning('Your plan is expired, Please purchase other plan', 'Oops !');
          //       this.router.navigate(['/planselection']);
          //       return false;
          //     }

              isValid = this.getPermission(curentPage, loggedInUser.usersDetailsVM.planPermission, loggedInUser.usersDetailsVM.planId)
          // }
          // else {
          //   this.toastr.warning('Your plan is expired, Please purchase plan', 'Oops !');
          //   this.router.navigate(['/planselection']);
          //   return false;
          // }
        }
        else if (loggedInUser.usersDetailsVM.planId == UserSelectedPlan.Advanced) {
          if (loggedInUser.usersDetailsVM.isPlanExpiried == false) {
            isValid = this.getPermission(curentPage, loggedInUser.usersDetailsVM.planPermission, loggedInUser.usersDetailsVM.planId)
          }
          else {
            this.toastr.warning('Your plan is expired, Please purchase plan', 'Oops !');
            this.router.navigate(['/planselection']);
            return false;
          }
        }
        else if (loggedInUser.usersDetailsVM.planId == UserSelectedPlan.Pro) {
          if (loggedInUser.usersDetailsVM.isPlanExpiried == false) {
            isValid = this.getPermission(curentPage, loggedInUser.usersDetailsVM.planPermission, loggedInUser.usersDetailsVM.planId)
          }
          else {
            this.toastr.warning('Your plan is expired, Please purchase plan', 'Oops !');
            this.router.navigate(['/planselection']);
            return false;
          }
        }
        else if (loggedInUser.usersDetailsVM.planId == UserSelectedPlan.ProPlus) {
          if (loggedInUser.usersDetailsVM.isPlanExpiried == false) {
            isValid = this.getPermission(curentPage, loggedInUser.usersDetailsVM.planPermission, loggedInUser.usersDetailsVM.planId)
          }
          else {
            this.toastr.warning('Your plan is expired, Please purchase plan', 'Oops !');
            this.router.navigate(['/planselection']);
            return false;
          }
        }
        else {
          this.toastr.warning('You do not have permission, Please purchase the plan', 'Oops !');
          this.router.navigate(['/planselection']);
          return false;
        }
        if (isValid == false) {
          this.toastr.warning('You do not have permission, Please purchase the plan', 'Oops !');
          this.router.navigate(['/planselection']);
          return false;
        }
        else {
          return true;
        }
      }
    }
    else {
      //this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
      openLoginModal(state.url);
      return false;
    }

  }
  getPermission(curentPage, planPermission, planId) {
    var isValid = false;
    if (planPermission != null && planPermission != '') {
      var planData = planPermission.split(',');
      if (planData != null && planData.length > 0) {


          if (planData.includes(PlanPermissions.SimpleSearch.toString())) {
            if (curentPage == PagePermission.Searchresult || curentPage == PagePermission.Raterequest || curentPage == PagePermission.Raterequestlist
              || curentPage == PagePermission.Bookinglist || curentPage == PagePermission.Bookingdetail || curentPage == PagePermission.Voyagedetail) {
                isValid = true;
            }
          }

        if (planData.includes(PlanPermissions.QuickestSearch.toString())) {
          if (curentPage == PagePermission.Searchresult || curentPage == PagePermission.Raterequestlist || curentPage == PagePermission.Bookinglist
            || curentPage == PagePermission.Voyagedetail || curentPage == PagePermission.Raterequest || curentPage == PagePermission.Bookingdetail) {
              isValid = true;
          }
        }
        if (planData.includes(PlanPermissions.PriceSearch.toString())) {
          if (curentPage == PagePermission.Searchresult || curentPage == PagePermission.Raterequestlist || curentPage == PagePermission.Bookinglist
            || curentPage == PagePermission.Voyagedetail || curentPage == PagePermission.Raterequest || curentPage == PagePermission.Bookingdetail) {
              isValid = true;
          }
        }
        if (planData.includes(PlanPermissions.FullPortCalendar.toString())) {
          if ( curentPage == PagePermission.Portcalendar) {
            isValid = true;
          }
        }
        if (planData.includes(PlanPermissions.FreigthQuotations.toString())) {
          if (curentPage == PagePermission.Searchresult || curentPage == PagePermission.Raterequestlist || curentPage == PagePermission.Bookinglist
             || curentPage == PagePermission.Raterequest || curentPage == PagePermission.Raterequest || curentPage == PagePermission.Bookingdetail) {
              isValid = true;
          }
        }
        if (planData.includes(PlanPermissions.Analytics.toString())) {
          if (curentPage == PagePermission.Searchresult || curentPage == PagePermission.Raterequestlist || curentPage == PagePermission.Bookinglist
            || curentPage == PagePermission.Voyagedetail || curentPage == PagePermission.Analytics || curentPage == PagePermission.Raterequest
            || curentPage == PagePermission.Bookingdetail) {
              isValid = true;
          }
        }
        if (planData.includes(PlanPermissions.Tracking.toString())) {
          if ( curentPage == PagePermission.Tracking || curentPage == PagePermission.TrackingVoyage) {
            isValid = true;
          }
        }
      }
    }

    return isValid;
  }
}

